import axios from 'axios'
import { get } from './base'

const endPoint = '/api/v3/divisions'
export function getAll() {
  const source = axios.CancelToken.source()

  return get(endPoint, { cancelToken: source.token })
}
